module.exports = __webpack_public_path__ + "static/media/armarios.54069efb.png";